import { render } from "./CbDocument.vue?vue&type=template&id=30349b08&scoped=true&ts=true"
import script from "./CbDocument.vue?vue&type=script&lang=ts"
export * from "./CbDocument.vue?vue&type=script&lang=ts"

import "./CbDocument.vue?vue&type=style&index=0&id=30349b08&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30349b08"]])

export default __exports__